

<div class="row">


  <div class="col-md-12 padding-left-0px">
    <div class="card">
      <div class="card-header wh-header  font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px card-title-schedule-bb">
        <div class="row">
          <div class="col-md-4">
            Scans
          </div>
          <!--<div class="col-md-8 " *ngIf="showbutton">
            <button type="button" (click)="AddNew()" class="btn btn-primary btn-sm float-right"> Add</button>
          </div>-->
        </div>

      </div>
      <div class="card-body padding-top-0px">
        

      </div>
    </div>

  </div>

</div>




